import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon"]

  connect() {
    this.darkMode = false
    this.init()
  }

  init() {
    // Load theme from localStorage, default to light
    const savedTheme = localStorage.getItem('tv-program-theme')
    this.darkMode = savedTheme ? savedTheme === 'dark' : false
    this.applyTheme()
  }

  toggle() {
    this.darkMode = !this.darkMode
    this.saveTheme()
    this.applyTheme()
  }

  saveTheme() {
    const theme = this.darkMode ? 'dark' : 'light'
    localStorage.setItem('tv-program-theme', theme)
  }

  
  applyTheme() {
    if (this.darkMode) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }

    this.updateIcon()
    this.updateThemeColor()
  }

  updateIcon() {
    if (this.hasIconTarget) {
      if (this.darkMode) {
        // Sun icon for light mode
        this.iconTarget.innerHTML = '<circle cx="12" cy="12" r="4"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 2v2m0 16v2M4.22 4.22l1.42 1.42m12.72 12.72l1.42 1.42M2 12h2m16 0h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>'
      } else {
        // Moon icon for dark mode
        this.iconTarget.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"/>'
      }
    }
  }

  updateThemeColor() {
    const themeColorMeta = document.getElementById('theme-color')
    if (themeColorMeta) {
      themeColorMeta.setAttribute('content', this.darkMode ? '#111827' : '#ffffff')
    }
  }
}